module.exports = __webpack_public_path__ + "static/media/IconTemplates_-02.2c2e21e1.svg";